import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { ITipoAuditoriaModel } from "../../../../app/models/tipo-auditoria.model";
import { IUnidadeGestoraModel } from "../../../../app/models/unidade-gestora.model";
import { AuthService } from "../../../../app/services/auth.service";
import { TipoAuditoriaService } from "../../../../app/services/tipo-auditoria.service";
import { UnidadeGestoraService } from "../../../../app/services/unidade-gestora.service";
import { BaseListComponent } from "../../../../app/shared/components/base-list/base-list.component";
import Swal from "sweetalert2";
import { IPlanoAcaoFiltroModel, IPlanoAcaoModel } from "../../../models/plano-acao-model";
import { PlanoAcaoService } from "../../../services/plano-acao.service";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-plano-acao-filtro',
  templateUrl: './plano-acao-filtro.component.html',
  styleUrls: ['./plano-acao-filtro.component.scss']
})
export class PlanoAcaoFiltroComponent
  extends BaseListComponent
  implements OnInit, AfterViewInit {
  @Input() showButtonFilter: Boolean = true;
  public planoAcaoModel: IPlanoAcaoModel = {} as IPlanoAcaoModel;
  private filtro: IPlanoAcaoFiltroModel = {} as IPlanoAcaoFiltroModel;
  public filtroModel: IPlanoAcaoFiltroModel = {} as IPlanoAcaoFiltroModel;
  public unidadesGestoras = [] as IUnidadeGestoraModel[];
  public tiposAuditoria = [] as ITipoAuditoriaModel[];
  public listUnidadeGestoraId: number[] = [-1];
  public finalizados = [
    { codigo: true, descricao: "Sim" },
    { codigo: false, descricao: "Não" }
  ];

  public status = [
    { codigo: 1, descricao: "Em Elaboração" },
    { codigo: 2, descricao: "Em Avaliação" },
    { codigo: 3, descricao: "Avaliado" },
    { codigo: 4, descricao: "Em Execução" },
    { codigo: 5, descricao: "Concluído" },
    { codigo: 6, descricao: "Cancelado" },
    { codigo: 7, descricao: "Não Implementado" },
    { codigo: 8, descricao: "Implementado Parcialmente" },
    { codigo: 9, descricao: "Implementado Totalmente" }
  ];

  public tipos = [
    { codigo: 1, descricao: "Auditoria / Plano de Ação" }
  ];

  @Output() situacaoMudou = new EventEmitter<number>();

  constructor(
    public authService: AuthService,
    public toastr: ToastrService,
    private planoAcaoService: PlanoAcaoService,
    private unidadeGestoraService: UnidadeGestoraService,
    private tipoAuditoriaService: TipoAuditoriaService
  ) {
    super();
  }

  ngOnInit(): void { }

  ngAfterViewInit() {
    this.obterUnidadesGestoras();
    this.obterTiposAuditoria();
  }

  private obterTiposAuditoria() {
    this.tipoAuditoriaService
      .obterAtivos()
      .then((res) => {
        this.tiposAuditoria = res.dados;
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem.descricao);
      });
  }

  private obterUnidadesGestoras() {
    this.unidadeGestoraService
      .obterAtivos()
      .then((res) => {
        this.unidadesGestoras = res.dados;
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem.descricao);
      });
  }

  public async buscarComFiltro(): Promise<void> {

    this.filtro.tipo = this.filtroModel.tipo;
    this.filtro.prazoFinal = this.filtroModel.prazoFinal;
    this.filtro.numeroOsa = this.filtroModel.numeroOsa;
    this.filtro.status = this.filtroModel.status;
    this.filtro.unidadeGestoraId = this.filtroModel.unidadeGestoraId;
    this.filtro.tipoAuditoriaId = this.filtroModel.tipoAuditoriaId;
    this.filtro.itensPorPagina = 50;
    this.filtro.elaboracaoFinalizada = this.filtroModel.elaboracaoFinalizada;

    await this.setarFiltroUnidadesVinculadas();

    // NOVO: Notificar o PlanoAcaoListComponent sobre os filtros aplicados
    this.planoAcaoService.notificarFiltrosAplicados(this.filtro);

    this.planoAcaoService
      .obter(this.filtro)
      .then(() => { })
      .catch((error) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: "Filtro não aplicado, ocorreu um erro!",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      });
  }

  private async setarFiltroUnidadesVinculadas(): Promise<void> {

    const responsavelId = this.authService.usuario.id;

    try {
      const res = await this.planoAcaoService.obterUGsByResponsavelId(responsavelId);

      if (!res.dados || res.dados.length === 0) {
        this.listUnidadeGestoraId = [-1];
      }
      else {
        this.listUnidadeGestoraId = res.dados.map(u => u.value);
      }

      this.filtro.listUnidadeGestoraId = this.listUnidadeGestoraId;

    }
    catch (err) {
      this.toastr.error(err?.mensagem?.descricao ?? err, "Atenção");
    }
  }

}
